export default __webpack_public_path__ + "static/media/job_offer14_l.14c31480.jpg";